import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";

import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";

import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";

const EstimateModel = React.forwardRef((props, ref) => {
  // eslint-disable-next-line
  const [disabled, setDisabled] = useState(false);
  // const [getDropdownData, setDropdownData] = useState("");
  // const [getCustomer, setCustomer] = useState([]);
  const [getCompanyCode, setCompanyCode] = useState([]);

  /* pop failure modal data*/
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const loadMasterData = async () => {
    let obj1 = {
      codeType: "companyCode",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setCompanyCode(item?.data);
      } else {
        setCompanyCode([]);
        console.log(">> Error: Loading Company Code");
      }
    });
  };

  //getting customer name
  useEffect(() => {
    // getMasterData();
    loadMasterData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // eslint-disable-next-line

  //Validations
  const [validation, setValidation] = useState({
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
    receivedBy: "",
    receiverContactNumber: "",
  });
  //Customer drop down

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    cashRequestNr: "",
    cashRequestStatus: "",
    salesOfficerCode: "",
    salesOfficerName: "",
    customerCode: "",
    customerName: "",
    paymentPurpose: "",
    paymentMode: "",
    cashAmount: "",
    cashAmountInWords: "",
  };

  //handle cancel modal
  const handleCancel = () => {
    setEstimateRequest((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleSave = () => {
    // Update sales officer details before creating the object

    // Create the final object for the quotation
    let Obj = {
      data: estimateRequest,
      // userId: customerID,
    };

    // Log the object to the console
    console.log("estimateObj", Obj);
  };

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  // eslint-disable-next-line
  const [estimateRequest, setEstimateRequest] = useState({
    estimateDate: "",
    companyCode: "",
    customerCode: "",
    paymentTerms: "",
    estimatedAmount: "",
    validUntil: "",
    estimateNotes: "",
    salesOfficerName: "",
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEstimateRequest((prev) => ({ ...prev, [name]: value }));
    setValidation((prev) => ({ ...prev, [name]: "" })); // Clear validation error for the field
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Estimate</Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">ET</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Estimate</span>
                  <span className="subHeaderTitle">Estimate details</span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Estimate Date" // Changed
                            name="estimateDate" // Changed
                            id="estimateDate" // Changed
                            value={estimateRequest?.estimateDate} // Changed
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Company Name"
                            placeholder=""
                            data={getCompanyCode}
                            id="companyCode"
                            iconClassName="dropdownIcon"
                            name="companyCode"
                            code="companyCode"
                            description="companyCodeDesc"
                            setValue={estimateRequest.companyCode || ""} // Changed
                            // getvalue={setDropdownData}
                            required={true}
                            error={validation.companyCode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Customer Name"
                            placeholder=""
                            // data={getCustomer}
                            id="customerCode"
                            iconClassName="dropdownIcon"
                            name="customerCode"
                            code="customerCode"
                            description="customerNameDesc"
                            setValue={estimateRequest.customerCode || ""} // Changed
                            // getvalue={setDropdownData}
                            required={true}
                            error={validation.customerCode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            label="Payment Terms"
                            placeholder=""
                            // data={paymentTermsOptions}
                            id="paymentTerms"
                            iconClassName="dropdownIcon"
                            name="paymentTerms"
                            code="paymentTerms"
                            description="paymentTermsDesc"
                            setValue={estimateRequest.paymentTerms || ""} // Changed
                            // getvalue={setDropdownData}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Estimated Amount" // Changed
                            placeholder="Enter amount"
                            name="estimatedAmount" // Changed
                            id="estimatedAmount" // Changed
                            error={validation.estimatedAmount || ""} // Changed
                            value={estimateRequest.estimatedAmount || ""} // Changed
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Valid Until"
                            name="validUntil"
                            id="validUntil"
                            value={estimateRequest?.validUntil} // Changed
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Estimate Notes" // Changed
                            placeholder="Enter estimate notes"
                            name="estimateNotes" // Changed
                            id="estimateNotes" // Changed
                            value={estimateRequest.estimateNotes} // Changed
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Sales Officer Name"
                            name="salesOfficerName"
                            id="salesOfficerName"
                            value={estimateRequest.salesOfficerName} // Changed
                            onChange={handleInputChange}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
          // requiredfields={getErrorFields}
        />
      </Modal.Body>
    </Modal>
  );
});

export default EstimateModel;
